export const NEW_ALGO = 'NEW_ALGO'
export const OLD_ALGO = 'OLD_ALGO'
export const DESKTOP_VIEWMODE = 'DESKTOP'
export const VIRTUAL_TAG = 'virtual'
